"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  FontFamilyEn: 'Noto Sans, sans-serif',
  FontFamilyAr: 'Noto Kufi Arabic, sans-serif'
};